import { apiPaths } from '@core/http/apiPaths';
import { httpClient } from '@core/http/httpClient';
import { AccountFeatureFlagModel } from '@hwm/ui-lib';
import { UserMainAccountModel } from '@models/Account';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

export const getUserProfile = createAsyncThunk(`userProfile/getUserProfile`, async () => {
  const response: AxiosResponse<UserMainAccountModel> = await httpClient.get(apiPaths.accounts.mainAccount);

  return response.data;
});

export const getUserPermissions = createAsyncThunk(`userProfile/getUserPermissions`, async () => {
  const response: AxiosResponse<string[]> = await httpClient.get(apiPaths.accounts.permissions);

  return response.data;
});

export const getTopLvlFeatureFlags = createAsyncThunk(`userProfile/getTopLvlFeatureFlags`, async () => {
  const response: AxiosResponse<AccountFeatureFlagModel[]> = await httpClient.get(apiPaths.featureFlags.features);

  return response.data;
});

export const userProfileThunks = {
  getUserProfile,
  getUserPermissions,
  getTopLvlFeatureFlags,
};
